// require('dotenv').config()
export const defaultConf = {
  // url: process.env.REACT_API_URL,
  // url: process.env.NODE_ENV !== "development" ? "http://localhost:8080/api-v2/" : "https://api-v2.meditechindo.com/v2/",
  url: process.env.NODE_ENV === "development" ? "http://localhost:9000/api/" : "https://api.kogas.co.id/api/",
  baseUrl: process.env.REACT_BASE_URL,
  uploadUrl:  process.env.NODE_ENV === "development" ? "http://localhost:9000/api" : "https://api.kogas.co.id/api",
  downloadUrl: process.env.NODE_ENV === "development" ? "http://localhost:9000/api/download" : "https://api.kogas.co.id/api/download",
  pasien_role_id: "6357b57bd9ff5ca93acb1d5d",
  dokter_role_id: "6357b565d9ff5ca93acb1d53",
  dokter_admin_role_id: "63a3056cdba1616c0b08345f",
  perawat_role_id: "6357b572d9ff5ca93acb1d58",
  permissionSource: process.env.REACT_APP_PERMISSIONS_SOURCE,
}
